module.exports = __webpack_public_path__ + "sx5-040bf8ad.png";